import type { CoreState } from './state'
import { locate, rows } from './tree-read'

/** The current row must be the toggle's header, not a block in its nested body. */
export function toggleHeaderItem(state: CoreState): string | undefined {
  if (!state.selection || state.scope || state.selection.nodes?.length) return undefined
  const entries = rows(state.blocks)
  const row = entries[locate(entries, state.selection.focus).row]
  const item = row?.parents.at(-1)
  const list = row?.parents.at(-2)
  return item?.type === 'li' && list?.type === 'list' && list.subtype === 'toggle' && item.children[0] === row.block
    ? item.id : undefined
}
